import React, { useState } from "react";
import {Box} from "@mui/material";
import "./ObjectiveAccordion.scss";
import CustomButtonWithIcon from "components/CustomButtonWithIcon/Buttons"
import { ReactComponent as IconAIWhite } from 'assets/images/IconAIWhite.svg'
import { ReactComponent as IconAIGreen } from 'assets/images/IconAIGreen.svg'
import { validateAudienceType } from "features/meta-travel-ads-campaign/Utils/validators/audienceValidators";

const objectives = [
  {
    id: "RETARGETING",
    name: "Retargeting",
    description: "Retarget ads to people who interacted with your products on and off Facebook",
    isAI: false
  },
  {
    id: "PROSPECTING",
    name: "Prospecting Advantage+",
    description: "Find more prospective customers by showing your ads to people planning a trip",
    isAI: true
  },
  {
    id: "META_AUDIENCE",
    name: "Meta Audience",
    description: "Choose an audience from your connected Meta Platforms Ads account",
    isAI: false
  },
];

const ObjectiveAccordion = ({ selectedObjective, setSelectedObjective, isSharedAudienceEnabled = false }) => {
  const [hoveredId, setHoveredId] = useState(null);

  const handleAudienceTypeBlur = async () => {
    await validateAudienceType(selectedObjective);
  };

  const visibleObjectives = objectives.filter(
    (obj) => obj.id !== "META_AUDIENCE" || isSharedAudienceEnabled
  );

  return (
    <Box className="meta-travel-ads-form-objective">
      <Box className="meta-travel-ads-form-objective-buttons">
        {visibleObjectives.map((objective) => {
          const isHighlighted = selectedObjective === objective.id || hoveredId === objective.id;
          return (
            <CustomButtonWithIcon
              key={objective.id}
              className={`objectiveButton ${selectedObjective === objective.id ? "selected" : ""}`}
              color="white"
              hoverColor="#12794F"
              width="240px"
              height="120px"
              titleColor="black"
              hoverTitleColor={"white"}
              borderRadius="10px"
              title=""
              textStyle={{
                fontFamily: "Inter",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "1.4",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                width: "100%",
                height: "100%",
              }}
              onClick={() => setSelectedObjective(objective.id)}
              onBlur={handleAudienceTypeBlur}
              onMouseEnter={() => setHoveredId(objective.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <div className="objective-name">{objective.name}</div>
              <span
                className="objective-description"
                style={{ color: isHighlighted ? "#fff" : "#6B7280" }}
              >
                {objective.description}
              </span>
              {objective.isAI && (
                <span style={{ position: "absolute", top: "8px", right: "8px" }}>
                  {selectedObjective === objective.id ? (
                    <IconAIWhite fontSize="26px" />
                  ) : (
                    <IconAIGreen fontSize="26px" />
                  )}
                </span>
              )}
            </CustomButtonWithIcon>
          );
        })}
      </Box>
    </Box>
  );
};

export default ObjectiveAccordion;
